import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import {} from 'rxjs';
import { PersonaService } from '../../../../core/services/persona.service';
import { activity, IroleProcessActivity } from 'src/app/shared/models/activity';
import { correspondence } from 'src/app/shared/models/correspondence';
import { TableService } from 'src/app/core/services/table.service';
import { AssociateService } from '../../services/associate.service';
import { SchedulerCandidate, ActivityModel } from 'src/app/shared/models/schedulerAssociate';
import { DashboardCandidate } from 'src/app/shared/models/candidate';
import { GetAllActivities } from 'src/app/shared/models/getallactivities';
import { EventDetails } from 'src/app/shared/models/event';
import { GetAllCandidates } from 'src/app/shared/models/getAllCandidates';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';
import { RoleService } from 'src/app/core/services/role.service';
import { process } from 'src/app/shared/models/process';
import {
  CheckSuitabilityDataObj,
  CheckInterviewSchDataObj,
  CheckstatusChangeObj,
  CorrespondenceDataObj,
} from 'src/app/shared/models/createschedule';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import {
  IDeleteDataObj,
  HrPanelInterviewObj,
  DataIds,
  isApplicantsActivityAvailable,
  IDeleteConfDataObj,
} from 'src/app/shared/models/activity-dashboard-model';
import { ActivityService } from 'src/app/core/services/activity.service';
import { RecruiterCandidates, ApplicationList } from 'src/app/shared/models/recruiterCandidates';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-candidates',
  templateUrl: './candidates.component.html',
  styleUrls: ['./candidates.component.scss'],
  standalone: false,
})
export class CandidatesComponent implements OnInit, OnChanges, OnDestroy {
  // data: PublicationSave;
  @Input() processStage: any;
  @Input() processCandidateData: RecruiterCandidates[] = [];
  @Input() candidatesList: SchedulerCandidate[];
  @Input() activityList: activity[];
  @Input() selectedEvent: EventDetails;
  @Input() checkData;
  @Input() roleCode: string;
  @Output() onCandidateReject: EventEmitter<boolean> = new EventEmitter();
  @Output() refreshpostingcandiates: EventEmitter<any> = new EventEmitter();
  @ViewChild('trigger') trigger: MatMenuTrigger;
  ripplecolor: string = 'rgba(237,207,255,0.5)';
  selectedCandidate: SchedulerCandidate[];
  correspondenceFlag: boolean;
  rejectionFlag: boolean;
  scheduleFlag: boolean;
  servicesList: string[] = ['Correspondence', 'ReSchedule', 'Rejection'];
  correspondenceObj: correspondence;
  rejectionObj: correspondence;
  scheduleObj: correspondence;
  filterFlag: boolean = false;
  // selectFilter: string[] = ["To be called", "Called", "Rejected"];
  // selectedFilter: string = "To be called";
  // selectFilter: string[] = ["To be called", "Called", "Rejected"];
  dataSource: DashboardCandidate[] = [];
  hoverIndex: number = null;
  correspondenceAttachment: File[];
  rejectionFile: File[];
  candidateBasicDetails: any;
  candidateEmails: string[] = [];
  message: string = '';
  activities: GetAllActivities[];
  candidateDetails: GetAllCandidates[];
  activity: string[] = ['All', 'Source', 'Technology'];
  selectedActivity: string = this.activity[0];
  eventData: EventDetails[];
  loginUserName: string;
  loginEmpNo: string;
  skills: SchedulerCandidate[];
  skillDisplay: string[] = [];
  sourceDisplay: any = [];
  skillCheck: any = [];
  sourceList: any = [];
  tempCandidateList: SchedulerCandidate[];
  activityModel: ActivityModel[];
  groupedActivities: any;
  candAppIds: object;
  hideTech: boolean = true;
  hideSource: boolean = true;
  sourceFlag: boolean = true;
  technologyFlag: boolean = true;
  processId: number;
  selectFirstCandidate: boolean = true;
  editactivityflag = false;
  modifyObj: any;
  candidateId: any;
  resumeData;
  fileId;
  resData;
  availableData: boolean = false;
  data = {
    // Required
    type: 'Candidates Page', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  candidateListData: ApplicationList[] = [];
  processActivityList: IroleProcessActivity[] = [];
  activityState: boolean = false;
  processList: process[];
  candidateApplicationIds: number[] = [];
  interviewFlag: boolean = false;
  // activity part starts

  onPreScreen: boolean = false;
  onScreen: boolean = false;
  onInterview: boolean = false;
  checkSuitabilityDataObj: CheckSuitabilityDataObj;
  checkInterviewSchDataObj: CheckInterviewSchDataObj;
  checkStatusChangeObj: CheckstatusChangeObj;
  correspondenceDataObj: CorrespondenceDataObj;
  checkHrPanelInterviewObj: HrPanelInterviewObj;
  onHrPanelInterview: boolean = false;
  onSuitability: boolean = false;
  onCorrespondence: boolean = false;

  onInterviewSchedule: boolean = false;

  onStatusChangeSchedule: boolean = false;

  //edit variables
  onSuitabilityEdit: boolean = false;
  onCorrespondenceEdit: boolean = false;
  onInterviewScheduleEdit: boolean = false;
  onStatusChangeScheduleEdit: boolean = false;
  onHrPanelInterviewEdit: boolean = false;

  coupledOnStatusChangeScheduleEdit: boolean = false;
  coupledOnSuitabilityEdit: boolean = false;
  coupledOnCorrespondenceEdit: boolean = false;
  coupledOnInterviewScheduleEdit: boolean = false;
  coupledhrpanelInterviewEdit: boolean = false;

  // coupled variables
  ifCoupled: boolean = false;
  coupledCheckSuitabilityDataObj: CheckSuitabilityDataObj;
  coupledCheckInterviewSchDataObj: CheckInterviewSchDataObj;
  coupledCheckStatusChangeObj: CheckstatusChangeObj;
  couplledCorrespondenceDataObj: CorrespondenceDataObj;
  coupledcheckHrPanelInterviewObj: HrPanelInterviewObj;
  coupledOnStatusChangeSchedule: boolean = false;
  coupledOnSuitability: boolean = false;
  coupledOnCorrespondence: boolean = false;
  coupledOnInterviewSchedule: boolean = false;
  coupledhrpanelInterview: boolean = false;
  coupledEditHrPanelInterview: boolean = false;

  coupled2CheckSuitabilityDataObj: CheckSuitabilityDataObj;
  coupled2CheckInterviewSchDataObj: CheckInterviewSchDataObj;
  coupled2CheckStatusChangeObj: CheckstatusChangeObj;
  couplled2CorrespondenceDataObj: CorrespondenceDataObj;
  coupled2checkHrPanelInterviewObj: HrPanelInterviewObj;
  coupled2OnStatusChangeSchedule: boolean = false;
  coupled2OnSuitability: boolean = false;
  coupled2OnCorrespondence: boolean = false;
  coupled2OnInterviewSchedule: boolean = false;
  coupled2hrpanelInterview: boolean = false;

  @Input() application;
  editcheckSuitabilityDataObj: CheckSuitabilityDataObj;
  coupledEditCheckSuitabilityDataObj1: CheckSuitabilityDataObj;
  coupledEditCheckSuitabilityDataObj2: CheckSuitabilityDataObj;
  // = <CheckSuitabilityDataObj> {};
  editcheckCorrespondenceDataObj: CorrespondenceDataObj;
  coupledEditCheckCorrespondenceDataObj1: CorrespondenceDataObj;
  coupledEditCheckCorrespondenceDataObj2: CorrespondenceDataObj;

  // =<CorrespondenceDataObj>{};
  editcheckInterviewDataObj: CheckInterviewSchDataObj;
  coupledEditCheckInterviewDataObj1: CheckInterviewSchDataObj;
  coupledEditCheckInterviewDataObj2: CheckInterviewSchDataObj;

  // = <CheckInterviewSchDataObj>{};
  editcheckStatusChangeDataObj: CheckstatusChangeObj;
  coupledEditCheckStatusChangeDataObj1: CheckstatusChangeObj;
  coupledEditCheckStatusChangeDataObj2: CheckstatusChangeObj;

  editcheckHrPanelInterviewObj: HrPanelInterviewObj;
  coupledEditCheckHrPanelInterviewObj1: HrPanelInterviewObj;
  coupledEditCheckHrPanelInterviewObj2: HrPanelInterviewObj;
  enabled: boolean;

  updateSuitability($event) {
    this.trigger.closeMenu();
    //this.onSuitability = $event;
    const obj: CheckSuitabilityDataObj = $event;
    this.onSuitability = obj.isVisible;
    this.checkSuitabilityDataObj = obj;
    console.log('HERE !!!!!');
    console.log(obj);
  }

  updateifcoupled(_$event) {
    this.trigger.closeMenu();
    this.ifCoupled = true;
  }

  updateInterviewSchedule($event) {
    this.trigger.closeMenu();
    // this.onInterview = $event;
    console.log($event);

    const InterviewObj: CheckInterviewSchDataObj = $event;
    this.onInterviewSchedule = InterviewObj.isVisisble;
    this.checkInterviewSchDataObj = InterviewObj;
    this.interviewFlag = true;
    console.log('Hi');

    console.log(this.checkInterviewSchDataObj);
  }

  updateCorrespondence($event) {
    this.trigger.closeMenu();
    //this.onCorrespondence = $event;
    const UpdateObj: CorrespondenceDataObj = $event;
    this.onCorrespondence = UpdateObj.isVisible;
    this.correspondenceDataObj = UpdateObj;
    console.log('corrospendence obj', this.correspondenceDataObj);
  }

  updateHrPanelChange($event) {
    this.trigger.closeMenu();
    const HrPanelObj: HrPanelInterviewObj = $event;
    this.onHrPanelInterview = HrPanelObj.isVisible;
    this.checkHrPanelInterviewObj = HrPanelObj;
    console.log('inhrinterview obj ');
  }

  updateStatusChange($event) {
    this.trigger.closeMenu();
    const statusChangeObj: CheckstatusChangeObj = $event;
    this.onStatusChangeSchedule = statusChangeObj.isVisisble;
    this.checkStatusChangeObj = statusChangeObj;
    console.log('HiStatusChange');
    console.log(this.checkStatusChangeObj);
  }

  updateROA($event) {
    this.updateSuitability($event);
  }

  updatePreScreenProcess($event) {
    this.onPreScreen = $event;
  }

  updateScreenProcess($event) {
    this.onScreen = $event;
  }

  updateInterviewProcess($event) {
    this.onInterview = $event;
  }

  //coupled update methods

  updateSuitabilityCoupled($event) {
    //this.onSuitability = $event;
    const SutabilityObj: CheckSuitabilityDataObj = $event;
    this.coupledOnSuitability = SutabilityObj.isVisible;
    this.coupledCheckSuitabilityDataObj = SutabilityObj;
    console.log(this.coupledOnSuitability);
    console.log('HERE !!!!!');
    console.log(SutabilityObj);
  }

  updateInterviewScheduleCoupled($event) {
    // this.onInterview = $event;
    console.log($event);

    const InSchObj: CheckInterviewSchDataObj = $event;
    this.coupledOnInterviewSchedule = InSchObj.isVisisble;
    this.coupledCheckInterviewSchDataObj = InSchObj;
    console.log('Hi');
    this.interviewFlag = true;
    console.log(this.coupledCheckInterviewSchDataObj);
  }

  updateCorrespondenceCoupled($event) {
    console.log('inside update event');
    //this.onCorrespondence = $event;
    const CorrObj: CorrespondenceDataObj = $event;
    this.coupledOnCorrespondence = CorrObj.isVisible;
    this.couplledCorrespondenceDataObj = CorrObj;
    console.log('corrospendence obj', this.couplledCorrespondenceDataObj);
  }

  updateStatusChangeCoupled($event) {
    const ststusChangeObj: CheckstatusChangeObj = $event;
    this.coupledOnStatusChangeSchedule = ststusChangeObj.isVisisble;
    this.coupledCheckStatusChangeObj = ststusChangeObj;
    console.log('HiStatusChange');

    console.log(this.coupledCheckStatusChangeObj);
  }

  updateHrPanelChangeCoupled($event) {
    this.trigger.closeMenu();
    const HrPanelInterviewObj: HrPanelInterviewObj = $event;
    this.coupledhrpanelInterview = HrPanelInterviewObj.isVisible;
    this.coupledcheckHrPanelInterviewObj = HrPanelInterviewObj;
    console.log('inhrinterview obj ');
  }

  // coupled 2 methods

  updateSuitabilityCoupled2($event) {
    //this.onSuitability = $event;
    const SuitabilityObj: CheckSuitabilityDataObj = $event;
    this.coupled2OnSuitability = SuitabilityObj.isVisible;
    this.coupled2CheckSuitabilityDataObj = SuitabilityObj;
    console.log(this.coupled2OnSuitability);
    console.log('HERE !!!!!');
    console.log(SuitabilityObj);
  }

  updateInterviewScheduleCoupled2($event) {
    // this.onInterview = $event;
    console.log($event);

    const InterviewSchDataObj: CheckInterviewSchDataObj = $event;
    this.coupled2OnInterviewSchedule = InterviewSchDataObj.isVisisble;
    this.coupled2CheckInterviewSchDataObj = InterviewSchDataObj;
    console.log('Hi');
    this.interviewFlag = true;

    console.log(this.coupled2CheckInterviewSchDataObj);
  }

  updateCorrespondenceCoupled2($event) {
    console.log('inside update event');
    //this.onCorrespondence = $event;
    const CorrespondenceDataObj: CorrespondenceDataObj = $event;
    this.coupled2OnCorrespondence = CorrespondenceDataObj.isVisible;
    this.couplled2CorrespondenceDataObj = CorrespondenceDataObj;
    console.log('corrospendence obj', this.couplled2CorrespondenceDataObj);
  }

  updateStatusChangeCoupled2($event) {
    const CheckstatusChangeObj: CheckstatusChangeObj = $event;
    this.coupled2OnStatusChangeSchedule = CheckstatusChangeObj.isVisisble;
    this.coupled2CheckStatusChangeObj = CheckstatusChangeObj;
    console.log('Hi,StatusChange2');

    console.log(this.coupled2CheckStatusChangeObj);
  }
  updateHrPanelChangeCoupled2($event) {
    this.trigger.closeMenu();
    const HrPanelInterviewObj: HrPanelInterviewObj = $event;
    this.coupled2hrpanelInterview = HrPanelInterviewObj.isVisible;
    this.coupled2checkHrPanelInterviewObj = HrPanelInterviewObj;
    console.log('inhrinterview obj ');
  }

  // activity part ends

  // allFlag: boolean;
  constructor(
    private operationsPersonaService: PersonaService,
    private activityService: ActivityService,
    private _telemetryServices: TelemetryServices,
    private _tableService: TableService,
    private _personaService: PersonaService,
    private roleService: RoleService,
    public dialog: MatDialog,
    private associateService: AssociateService,
    private changeDetector: ChangeDetectorRef,
    private fileDownloadService: FileDownloadService
  ) {
    // this.dataSource = new ApplicantDataSource(this.operationsPersonaService);
    // console.log('candy',this.dataSource);
  }

  ngOnChanges() {
    if (!this.checkData) {
      this.availableData = false;
      console.log('called here');

      // if (this.candidatesList) {
      this.tempCandidateList = this.candidatesList;
      console.log('temp', this.tempCandidateList);
      // this.selectedCandidate = null;
      this.setSourceList();
      this.setSkillList();
      this.processCandidateData.forEach((element) => {
        if (element.processName.toLowerCase() === this.processStage.toLowerCase()) {
          this.candidateListData = element.applicationList;
          console.log(this.candidateListData);
          if (this.candidateListData.length > 0) {
            this.availableData = false;
          } else {
            this.availableData = true;
          }
        }
      });
      // }
    } else {
      this.availableData = true;
    }
  }

  ngOnInit() {
    this.roleCode = localStorage.getItem('role');
    // if (this.roleCode == '') {
    //   this.roleCode = 'Recruiter';
    // }
    this.getFooterActivities();
    // this.getFooterProcess();
    if (this.checkData) {
      console.log(this.candidatesList);
      this.roleService.getRole().subscribe((res) => {
        console.log(res);
        res.forEach((obj) => {
          if (obj.role.toLowerCase() === 'scas') {
            this.processId = obj.processId[0];
          }
          this.roleService.setProcessId(this.processId);
        });
        console.log(this.processId);
      });
      this.processCandidateData.forEach((element) => {
        if (element.processName.toLowerCase() === this.processStage.toLowerCase()) {
          this.candidateListData = element.applicationList;
          if (this.candidateListData.length > 0) {
            this.availableData = false;
          } else {
            this.availableData = true;
          }
        }
      });
      this._personaService.getLoggedUserDetails().subscribe(
        (res) => {
          if (res) {
            // console.log('data ---->', data, typeof data);
            this.loginUserName = res.empName;
            this.loginEmpNo = res.empNo;
            this.modifyObj = { modifiedBy: this.loginEmpNo, modifiedOn: new Date() };
          }
        },
        (_err) => {
          // console.log('error',err.status);
        },
      );

      this.data.subtype = 'candidates';
      this.data.pageid = '0';
      this.data.itype = 'AUTO';
      this.data.stageto = 'initial page loading';
      if (this.data) {
        this._telemetryServices.telemetryImpression(this.data);
      }
      this._tableService.getCandidateID().subscribe((_res) => {
        // console.log(data);
      });
      // this.getAllActivities();
      this.getCandidateListByIds();

      // this.operationsPersonaService.getDashboardCandidateBatch()
      //   .subscribe(
      //     (data) => {
      //       this.dataSource = data;
      //     }
      //   )
      // this.tempCandidateList = this.candidatesList;
      // this.setSourceList();
      // this.setSkillList();
      if (this.candidatesList) {
        this.tempCandidateList = this.candidatesList;
        console.log(this.tempCandidateList);
        console.log(this.candidatesList);
        this.setSourceList();
        console.log(this.sourceList);
        this.setSkillList();
      }
    } else {
      this.availableData = true;
    }
  }

  setSourceList() {
    if (this.candidatesList) {
      this.candidatesList.forEach((candidate) => {
        if (candidate.sourceNames) {
          candidate.sourceNames.forEach((res) => this.sourceDisplay.push(res));
        }
      });
      const unique = this.sourceDisplay.filter((elem, index, self) => {
        return index === self.indexOf(elem);
      });
      this.sourceDisplay = unique;
    }
  }

  setSkillList() {
    console.log(this.candidatesList);
    if (this.candidatesList) {
      for (const candidate of this.candidatesList) {
        if (candidate.candidateSkills != null) {
          for (const canSkill of candidate.candidateSkills) {
            for (const skill of canSkill.primarySkill) {
              console.log(skill);

              if (this.skillDisplay.length < 1) {
                this.skillDisplay.push(skill);
              } else {
                let flag = true;
                for (const skills of this.skillDisplay) {
                  if (skills == skill) {
                    flag = false;
                  }
                }
                if (flag) {
                  this.skillDisplay.push(skill);
                }
              }
            }
          }
        }
      }
    }
    // telemtry interact call
  }

  getFooterActivities() {
    console.log('get footer activities called');

    this.associateService.getProcessActivities(this.roleCode).subscribe((resp) => {
      console.log(resp);
      console.log('inside get process activities');

      const data1 = resp.processModel;
      console.log('processModel', data1);
      this.processActivityList = data1;
      // data.forEach(element =>{
      //   console.log('model elemnt',element);
      //   this.processActivityList.push(element)

      // })
      // // this.processActivityList = res;
      console.log('processlist', this.processActivityList);
    });
    // this.associateService.getActivities().subscribe(res => {
    //   console.log(res);
    //   this.processActivityList = res;
    // })
  }
  getActivities(items: any) {
    console.log('accord clicked');
    console.log('this accord selected', items);
    this.activityList = items.activityprocess;
  }

  editactivity(editactivity1: any) {
    this.editcheckSuitabilityDataObj = undefined;
    this.editcheckCorrespondenceDataObj = undefined;
    this.editcheckInterviewDataObj = undefined;
    this.editcheckStatusChangeDataObj = undefined;
    this.editcheckHrPanelInterviewObj = undefined;

    this.coupledEditCheckCorrespondenceDataObj1 = undefined;
    this.coupledEditCheckHrPanelInterviewObj1 = undefined;
    this.coupledEditCheckInterviewDataObj1 = undefined;
    this.coupledEditCheckStatusChangeDataObj1 = undefined;
    this.coupledEditCheckSuitabilityDataObj1 = undefined;

    this.coupledEditCheckCorrespondenceDataObj2 = undefined;
    this.coupledEditCheckHrPanelInterviewObj2 = undefined;
    this.coupledEditCheckInterviewDataObj2 = undefined;
    this.coupledEditCheckStatusChangeDataObj2 = undefined;
    this.coupledEditCheckSuitabilityDataObj2 = undefined;

    this.onSuitabilityEdit = false;
    this.onCorrespondenceEdit = false;
    this.onInterviewScheduleEdit = false;
    this.onStatusChangeScheduleEdit = false;
    this.onHrPanelInterviewEdit = false;

    this.coupledOnStatusChangeScheduleEdit = false;
    this.coupledOnSuitabilityEdit = false;
    this.coupledOnCorrespondenceEdit = false;
    this.coupledOnInterviewScheduleEdit = false;
    this.coupledhrpanelInterviewEdit = false;

    const tempIdObj: DataIds = {
      applicationId: Number(this.selectedCandidate[0].applicationId),
      processID: editactivity1.processId,
      activityID: editactivity1.activityId,
    };
    this.activityService.setDataIds(tempIdObj);
    let isapplicantData: any;
    this.activityService.isApplicantsActivityAvailable().subscribe((data: isApplicantsActivityAvailable) => {
      console.log(data);

      console.log('editactivity1--->', editactivity1, 'candidateemails---', this.candidateEmails);
      this.editactivityflag = !this.editactivityflag;
      console.log('this selected activity', editactivity1);
      console.log(this.editactivityflag);
      const coupledActivity = data.coupledctivityTypeIsExists;
      console.log(coupledActivity);

      const activitytype = editactivity1.activityType.toLowerCase();
      console.log('acttity vtype', activitytype);
      console.log(isapplicantData);
      console.log(data.coupledctivityTypeIsExists);

      // if(true)
      if (data.coupledctivityTypeIsExists) {
        console.log('inside if couple');
        this.ifCoupled = true;

        this.editCoupleActivity(activitytype, data.coupledctivityType.toLowerCase(), editactivity1, data);
        // this.editCoupleActivity(activitytype,'simple activity',editactivity1,data)

        console.log();
      } else {
        console.log('ifcoupl--->', this.ifCoupled);
        this.ifCoupled = false;
        if (activitytype) {
          switch (activitytype) {
            case 'simple activity': {
              console.log('in -----', activitytype);
              const editcheckSuitabilityDataObj: CheckSuitabilityDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: editactivity1.activityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              console.log(editcheckSuitabilityDataObj);
              this.editcheckSuitabilityDataObj = editcheckSuitabilityDataObj;
              console.log(this.editcheckSuitabilityDataObj);
              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype);
              const editcheckCorrespondenceDataObj: CorrespondenceDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: editactivity1.activityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.editcheckCorrespondenceDataObj = editcheckCorrespondenceDataObj;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype);
              const editcheckInterviewDataObj: CheckInterviewSchDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: editactivity1.activityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.editcheckInterviewDataObj = editcheckInterviewDataObj;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype);
              let ishractivity = true;
              if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const editcheckHrPanelInterviewObj: HrPanelInterviewObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: editactivity1.activityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                statusId: editactivity1.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.editcheckHrPanelInterviewObj = editcheckHrPanelInterviewObj;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype);
              const editcheckStatusChangeDataObj: CheckstatusChangeObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: editactivity1.activityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.editcheckStatusChangeDataObj = editcheckStatusChangeDataObj;
              break;
            }
          }
        }
      }
    });
  }

  editCoupleActivity(activitytype1, coupledactivitytype1, editactivity1, data) {
    // data.coupledctivityType='simple correspondence';
    if (activitytype1) {
      switch (activitytype1) {
        case 'simple activity': {
          console.log('in -----', activitytype1);
          console.log(editactivity1.activityDescription);

          const couplededitcheckSuitabilityDataObj1: CheckSuitabilityDataObj = {
            candidateName: this.selectedCandidate[0].name,
            processId: editactivity1.processId,
            applicationId: Number(this.selectedCandidate[0].applicationId),
            activityId: editactivity1.activityId,
            isVisible: true,
            activityName: editactivity1.activityDescription,
            statusId: editactivity1.statusId,
            createdOn: editactivity1.createdOn,
            createdBy: editactivity1.createdBy,
          };

          this.coupledEditCheckSuitabilityDataObj1 = couplededitcheckSuitabilityDataObj1;
          this.onSuitabilityEdit = true;

          switch (coupledactivitytype1) {
            case 'simple activity': {
              console.log('in -----', activitytype1);
              console.log(editactivity1.activityDescription);

              const couplededitcheckSuitabilityDataObj2: CheckSuitabilityDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj2;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype1);
              const couplededitcheckCorrespondenceDataObj3: CorrespondenceDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,

                isVisible: true,
                // activityName: editactivity1.activityDescription,
                activityName: data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj3;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype1);
              const couplededitcheckInterviewDataObj3: CheckInterviewSchDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj3;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype1);
              let ishractivity = true;
              if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj3: HrPanelInterviewObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj3;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype1);
              const couplededitcheckStatusChangeDataObj3: CheckstatusChangeObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj3;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'simple correspondence': {
          console.log('in -----', activitytype1);
          const couplededitcheckCorrespondenceDataObj3: CorrespondenceDataObj = {
            candidateName: this.selectedCandidate[0].name,
            processId: editactivity1.processId,
            applicationId: Number(this.selectedCandidate[0].applicationId),
            activityId: editactivity1.activityId,
            isVisible: true,
            activityName: editactivity1.activityDescription,
            statusId: editactivity1.statusId,
            createdOn: editactivity1.createdOn,
            createdBy: editactivity1.createdBy,
            candidateId: this.selectedCandidate[0].candidateId,
          };
          this.coupledEditCheckCorrespondenceDataObj1 = couplededitcheckCorrespondenceDataObj3;
          this.onCorrespondenceEdit = true;

          switch (coupledactivitytype1) {
            case 'simple activity': {
              console.log('in -----', activitytype1);
              console.log(editactivity1.activityDescription);

              const couplededitcheckSuitabilityDataObj3: CheckSuitabilityDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj3;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype1);
              const couplededitcheckCorrespondenceDataObj3: CorrespondenceDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj3;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype1);
              const couplededitcheckInterviewDataObj3: CheckInterviewSchDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj3;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype1);
              let ishractivity2 = true;
              if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
                ishractivity2 = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                isHrActivity: ishractivity2,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype1);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'interview': {
          console.log('in -----', activitytype1);
          const couplededitcheckInterviewDataObj: CheckInterviewSchDataObj = {
            candidateName: this.selectedCandidate[0].name,
            processId: editactivity1.processId,
            applicationId: Number(this.selectedCandidate[0].applicationId),
            activityId: editactivity1.activityId,
            isVisisble: true,
            activityName: editactivity1.activityDescription,
            statusId: editactivity1.statusId,
            createdOn: editactivity1.createdOn,
            createdBy: editactivity1.createdBy,
            candidateId: this.selectedCandidate[0].candidateId,
          };
          this.coupledEditCheckInterviewDataObj1 = couplededitcheckInterviewDataObj;
          this.onInterviewScheduleEdit = true;

          switch (coupledactivitytype1) {
            case 'simple activity': {
              console.log('in -----', activitytype1);
              console.log(editactivity1.activityDescription);

              const couplededitcheckSuitabilityDataObj2: CheckSuitabilityDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj2;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype1);
              const couplededitcheckCorrespondenceDataObj2: CorrespondenceDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj2;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype1);
              const couplededitcheckInterviewDataObj2: CheckInterviewSchDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj2;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype1);
              let ishractivity = true;
              if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype1);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'confirmation': {
          console.log('in -----', activitytype1);
          let ishractivity = true;
          if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
            ishractivity = false;
          }
          const couplededitcheckHrPanelInterviewObj: HrPanelInterviewObj = {
            candidateName: this.selectedCandidate[0].name,
            processId: editactivity1.processId,
            applicationId: Number(this.selectedCandidate[0].applicationId),
            activityId: editactivity1.activityId,
            isVisible: true,
            activityName: editactivity1.activityDescription,
            statusId: editactivity1.statusId,
            isHrActivity: ishractivity,
            createdOn: editactivity1.createdOn,
            createdBy: editactivity1.createdBy,
          };
          this.coupledEditCheckHrPanelInterviewObj1 = couplededitcheckHrPanelInterviewObj;
          this.onHrPanelInterviewEdit = true;

          switch (coupledactivitytype1) {
            case 'simple activity': {
              console.log('in -----', activitytype1);
              console.log(editactivity1.activityDescription);

              const couplededitcheckSuitabilityDataObj2: CheckSuitabilityDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: data.coupledActivityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj2;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype1);
              const couplededitcheckCorrespondenceDataObj2: CorrespondenceDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj2;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype1);
              const couplededitcheckInterviewDataObj2: CheckInterviewSchDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj2;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype1);
              let ishractivity = true;
              if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype1);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              this.coupledOnStatusChangeScheduleEdit = true;
              break;
            }
          }

          break;
        }
        case 'status change': {
          console.log('in -----', activitytype1);
          const couplededitcheckStatusChangeDataObj: CheckstatusChangeObj = {
            candidateName: this.selectedCandidate[0].name,
            processId: editactivity1.processId,
            applicationId: Number(this.selectedCandidate[0].applicationId),
            activityId: editactivity1.activityId,

            isVisisble: true,
            activityName: editactivity1.activityDescription,
            statusId: editactivity1.statusId,
            createdOn: editactivity1.createdOn,
            createdBy: editactivity1.createdBy,
          };
          this.coupledEditCheckStatusChangeDataObj1 = couplededitcheckStatusChangeDataObj;
          this.onStatusChangeScheduleEdit = true;
          console.log(this.coupledEditCheckStatusChangeDataObj1);
          switch (coupledactivitytype1) {
            case 'simple activity': {
              console.log('in -----', activitytype1);
              console.log(editactivity1.activityDescription);

              const couplededitcheckSuitabilityDataObj2: CheckSuitabilityDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckSuitabilityDataObj2 = couplededitcheckSuitabilityDataObj2;
              this.coupledOnSuitabilityEdit = true;
              console.log(this.coupledEditCheckSuitabilityDataObj2);

              break;
            }
            case 'simple correspondence': {
              console.log('in -----', activitytype1);
              const couplededitcheckCorrespondenceDataObj2: CorrespondenceDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckCorrespondenceDataObj2 = couplededitcheckCorrespondenceDataObj2;
              this.coupledOnCorrespondenceEdit = true;
              break;
            }
            case 'interview': {
              console.log('in -----', activitytype1);
              const couplededitcheckInterviewDataObj2: CheckInterviewSchDataObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
                candidateId: this.selectedCandidate[0].candidateId,
              };
              this.coupledEditCheckInterviewDataObj2 = couplededitcheckInterviewDataObj2;
              this.coupledOnInterviewScheduleEdit = true;
              break;
            }
            case 'confirmation': {
              console.log('in -----', activitytype1);
              let ishractivity = true;
              if (editactivity1.activityDescription.toLowerCase().includes('panel')) {
                ishractivity = false;
              }
              const couplededitcheckHrPanelInterviewObj2: HrPanelInterviewObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                activityId: editactivity1.activityId,
                isVisible: true,
                activityName: editactivity1.activityDescription,
                // activityName:data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                isHrActivity: ishractivity,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckHrPanelInterviewObj2 = couplededitcheckHrPanelInterviewObj2;
              this.coupledhrpanelInterviewEdit = true;
              break;
            }
            case 'status change': {
              console.log('in -----', activitytype1);
              const couplededitcheckStatusChangeDataObj2: CheckstatusChangeObj = {
                candidateName: this.selectedCandidate[0].name,
                processId: editactivity1.processId,
                applicationId: Number(this.selectedCandidate[0].applicationId),
                // activityId: editactivity1.activityId,
                activityId: data.coupledActivityId,
                isVisisble: true,
                // activityName: editactivity1.activityDescription,
                activityName: data.coupleActivityDescription,
                statusId: editactivity1.statusId,
                createdOn: editactivity1.createdOn,
                createdBy: editactivity1.createdBy,
              };
              this.coupledEditCheckStatusChangeDataObj2 = couplededitcheckStatusChangeDataObj2;
              console.log(this.coupledEditCheckStatusChangeDataObj2);

              this.coupledOnStatusChangeScheduleEdit = true;
              console.log(this.coupledOnStatusChangeScheduleEdit);
              break;
            }
          }

          break;
        }
      }
    }
  }

  deleteActivityCard(activity) {
    console.log(activity.createdOn);
    // console.log(processId);
    // console.log(activityType);
    console.log(this.candidateApplicationIds);
    const _applicationId = this.candidateApplicationIds;
    console.log(this.selectedCandidate);
    const deleteObj: IDeleteDataObj = {
      // applicationId:[1408],//this.candidateApplicationIds,
      // processId:100101,//processId,
      // activityId:10//activityId
      applicationIds: this.candidateApplicationIds,
      processID: activity.processId,
      activityID: activity.activityId,
      createdOn: activity.createdOn,
    };

    const deleteConfObj: IDeleteConfDataObj = {
      applicationIds: this.candidateApplicationIds,
      activityId: activity.activityId,
      createdOn: activity.createdOn,
    };
    console.log(deleteObj);
    console.log(deleteConfObj);
    // if(activityType=="")

    switch (activity.activityType.toLowerCase()) {
      case 'simple activity': {
        this.activityService.deleteSimpleActivity(deleteObj).subscribe(
          (res) => {
            console.log(res);
            // this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            const data = {
              msg: 'Deleted Successfully',
              isSuccess: true,
            };
            // this.callrefreshcandiates(true);
            this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            this.activityService.openSnackBar(data, 'success-snack');
          },
          (err) => {
            console.log(err);
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );

        break;
      }

      case 'simple correspondence': {
        this.activityService.deleteCorrespondenceActivity(deleteObj).subscribe(
          (res) => {
            console.log(res);
            // this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            const data = {
              msg: 'Deleted Successfully',
              isSuccess: true,
            };
            // this.callrefreshcandiates(true);
            this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            this.activityService.openSnackBar(data, 'success-snack');
          },
          (err) => {
            console.log(err);
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );

        break;
      }

      case 'interview': {
        this.activityService.deleteInterviewActivity(deleteObj).subscribe(
          (res) => {
            console.log(res);
            // this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            const data = {
              msg: 'Deleted Successfully',
              isSuccess: true,
            };
            // this.callrefreshcandiates(true);
            this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            this.activityService.openSnackBar(data, 'success-snack');
          },
          (err) => {
            console.log(err);
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );

        break;
      }

      case 'status change': {
        this.activityService.deleteStatusChangeActivity(deleteObj).subscribe(
          (res) => {
            console.log(res);
            // this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            const data = {
              msg: 'Deleted Successfully',
              isSuccess: true,
            };
            // this.callrefreshcandiates(true);
            this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            this.activityService.openSnackBar(data, 'success-snack');
          },
          (err) => {
            console.log(err);
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );

        break;
      }

      case 'confirmation': {
        this.activityService.deleteConfirmationActivity(deleteConfObj).subscribe(
          (res) => {
            console.log(res);
            const data = {
              msg: 'Deleted Successfully',
              isSuccess: true,
            };
            // this.callrefreshcandiates(true);
            this.getActivitiesOnCandidate(this.selectedCandidate[0]);
            this.activityService.openSnackBar(data, 'success-snack');
          },
          (err) => {
            console.log(err);
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );
        break;
      }
    }
  }

  getFooterProcess() {
    this.associateService.getProcess().subscribe((res) => {
      console.log(res);
      this.processList = res;
    });
  }

  setActivityState() {
    this.reloadTree();
    console.log('new activyty selected,setting activity state true');
    this.activityState = true;
  }
  reloadTree() {
    this.enabled = false;
    // now notify angular to check for updates
    this.changeDetector.detectChanges();
    // change detection should remove the component now
    // then we can enable it again to create a new instance
    this.enabled = true;
  }

  // filterChange(filter){
  //   let name1;
  //   name1=this.activity[0]
  //   console.log(name1);

  //   if(filter=='Source'){
  //     this.hideTech = !this.hideTech;
  //   }
  //   else if(filter == 'Skill'){
  //     this.hideSource = !this.hideSource;
  //   }
  // }
  hidden(filterName) {
    if (filterName == 'Source') {
      this.hideTech = !this.hideTech;
    } else if (filterName == 'Skill') {
      this.hideSource = !this.hideSource;
    }
  }

  checkSource(sourceName) {
    let bool: boolean = false;
    let sourceIndex: number;
    if (this.sourceList.length > 0) {
      this.sourceList.forEach((item, index) => {
        if (item == sourceName) {
          bool = true;
          sourceIndex = index;
        }
      });
      if (bool) {
        this.sourceList.splice(sourceIndex, 1);
        bool = false;
      } else {
        this.sourceList.push(sourceName);
      }
    } else {
      this.sourceList.push(sourceName);
    }
    if (this.sourceList.length == 0) {
      this.tempCandidateList = this.candidatesList;
    } else {
      const temp = this.candidatesList;
      this.tempCandidateList = temp.filter((candidate) => {
        let flag = false;
        for (const source of this.sourceList) {
          if (candidate.sourceNames.find((x) => x.toLowerCase().includes(source.toLowerCase()))) {
            flag = true;
            break;
          }
        }
        if (flag) {
          return candidate;
        }
      });
    }
    // telemtry interact call

    this.data.subtype = 'event click';
    this.data.pageid = '2';
    this.data.itype = 'event click to filter the source values';
    this.data.stageto = 'changing the source values according to the filter';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }
  }

  checkTechnology(skill) {
    let bool: boolean = false;
    let skillIndex: number;
    if (this.skillCheck.length > 0) {
      this.skillCheck.forEach((item, index) => {
        if (item == skill) {
          bool = true;
          skillIndex = index;
        }
      });
      if (bool) {
        this.skillCheck.splice(skillIndex, 1);
        bool = false;
      } else {
        this.skillCheck.push(skill);
      }
    } else {
      this.skillCheck.push(skill);
    }
    if (this.skillCheck.length == 0) {
      this.tempCandidateList = this.candidatesList;
    } else {
      const temp: SchedulerCandidate[] = this.candidatesList;
      this.tempCandidateList = temp.filter((candidate) => {
        let flag = false;
        if (candidate.candidateSkills) {
          for (const sk of this.skillCheck) {
            for (const candidateSkill of candidate.candidateSkills) {
              for (const skills of candidateSkill.primarySkill) {
                if (sk == skills) {
                  flag = true;
                }
              }
            }
          }
          if (flag) {
            return candidate;
          }
        }
      });
    }
    // telemtry interact call
    this.data.subtype = 'event click';
    this.data.pageid = '2';
    this.data.itype = 'event click to filter the skills values';
    this.data.stageto = 'changing the skills values according to the filter';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }
  }

  getAllActivities() {
    this.associateService.getAllActivities().subscribe((data) => {
      console.log(data);
      this.activities = data;
      this.activities.push({ eventStatusId: 0, eventStatusDescription: 'Select' });
    });
  }
  getCandidateListByIds() {
    // this.associateService.getCandidateListByIds().subscribe((data) => {
    this.skills = this.candidatesList;
    // })
  }

  getEventDetails() {
    this.associateService.getEventDetails().subscribe((data) => {
      console.log(data);
      this.eventData = data;
    });
  }

  resetFlag = function () {
    console.log('Flag Reset Called');
    this.editactivityflag = false;
    this.ifCoupled = false;
    this.clearActivityObj();
  };

  callrefreshcandiates(val) {
    console.log('details----' + val);
    this.refreshpostingcandiates.emit(true);
  }

  getProfileData(data) {
    this.activityState = false;
    console.log('displayCandidate', data);

    this.selectedCandidate = [data]; // data[0]
    console.log('selectedCandidate from list', data);
    console.log('selectedCandidatein candidate details', data);
    this.candidateId = this.selectedCandidate[0].candidateId;
    console.log('selected candidate', this.selectedCandidate);
    this.candidateApplicationIds = [];
    this.candidateEmails = [];
    this.selectedCandidate.forEach((value) => {
      console.log('foreach of selectedcandidate', value);
      this.candidateApplicationIds.push(Number(value.applicationId));
      this.candidateEmails.push(String(value['emailId']));
    });
    console.log('new application ids', this.candidateApplicationIds);
    console.log('selected candidate email', this.candidateEmails);

    if (this.roleCode == 'Scheduler') {
      this.candAppIds = {
        candidateId: this.selectedCandidate[0].candidateId,
        applicationId: this.selectedCandidate[0].applicationId,
        screenName: 'Scheduler',
      };
    } else if (this.roleCode == 'Offer DEO') {
      this.candAppIds = {
        candidateId: this.selectedCandidate[0].candidateId,
        applicationId: this.selectedCandidate[0].applicationId,
        screenName: 'Offer_ViewProfile',
      };
    } else {
      this.candAppIds = {
        candidateId: this.selectedCandidate[0].candidateId,
        applicationId: this.selectedCandidate[0].applicationId,
        screenName: 'Scheduler',
      };
    }
    console.log(this.candAppIds);
    console.log('selected candidate[]0', this.selectedCandidate[0]);
    console.log('selected candidate', this.selectedCandidate);

    this.displayCandidate(this.selectedCandidate[0]);
    this.getActivitiesOnCandidate(this.selectedCandidate[0]);
    this.data.subtype = 'event click';
    this.data.pageid = '2';
    this.data.itype = 'particular event click';
    this.data.stageto = 'get the profile data';
    this.clearActivityObj();
  }

  clearActivityObj() {
    this.ifCoupled = false;
    this.checkSuitabilityDataObj = undefined;
    this.coupledCheckSuitabilityDataObj = undefined;
    this.correspondenceDataObj = undefined;
    this.couplledCorrespondenceDataObj = undefined;
    this.checkInterviewSchDataObj = undefined;
    this.coupledCheckInterviewSchDataObj = undefined;
    this.checkStatusChangeObj = undefined;
    this.coupledCheckStatusChangeObj = undefined;
    this.onSuitability = false;
    this.coupledOnSuitability = false;
    this.onCorrespondence = false;
    this.coupledOnCorrespondence = false;
    this.onInterview = false;
    this.onInterviewSchedule = false;
    this.coupledOnInterviewSchedule = false;
    this.onStatusChangeSchedule = false;
    this.coupledOnStatusChangeSchedule = false;
    this.checkHrPanelInterviewObj = undefined;
    this.onHrPanelInterview = false;
    this.coupledcheckHrPanelInterviewObj = undefined;
    this.coupled2checkHrPanelInterviewObj = undefined;
    this.coupled2CheckInterviewSchDataObj = undefined;
    this.coupled2CheckStatusChangeObj = undefined;
    this.coupled2CheckSuitabilityDataObj = undefined;
    this.coupled2OnCorrespondence = false;
    this.coupled2hrpanelInterview = false;
    this.coupled2OnInterviewSchedule = false;
    this.coupled2OnSuitability = false;
    this.coupled2OnStatusChangeSchedule = false;
    this.coupledcheckHrPanelInterviewObj = undefined;
    this.checkSuitabilityDataObj = undefined;
    this.coupledCheckSuitabilityDataObj = undefined;
    this.correspondenceDataObj = undefined;
    this.couplledCorrespondenceDataObj = undefined;
    this.checkInterviewSchDataObj = undefined;
    this.coupledCheckInterviewSchDataObj = undefined;
    this.checkStatusChangeObj = undefined;
    this.coupledCheckStatusChangeObj = undefined;
    this.onSuitability = false;
    this.coupledOnSuitability = false;
    this.onCorrespondence = false;
    this.coupledOnCorrespondence = false;
    this.onInterview = false;
    this.onInterviewSchedule = false;
    this.coupledOnInterviewSchedule = false;
    this.onStatusChangeSchedule = false;
    this.coupledOnStatusChangeSchedule = false;
    this.checkHrPanelInterviewObj = undefined;
    this.onHrPanelInterview = false;
    this.coupledcheckHrPanelInterviewObj = undefined;
  }

  openResume(data) {
    console.log(data);
    if (data && data.objectId && data.objectType && data.attachmentId) {
      this._personaService.getFileId(data).subscribe((data) => {
        this.fileId = data;
  
        this._personaService.getResume(this.fileId.id).subscribe(async (data) => {
          if (data) {
            this.resData = data;
            const fileType = this.fileDownloadService.normalizeFileType(this.resData.fileType);
            const mimeType = this.fileDownloadService.getMimeType(fileType);
            const fileBytes = await this.fileDownloadService.decodeFileBytes(this.resData.file.data);
            const blobBytes = new Uint8Array(fileBytes.byteLength);
            blobBytes.set(fileBytes);
            const file = new Blob([blobBytes.buffer], { type: mimeType });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        });
      });
    }
  }

  displayCandidate(selectedCandidate) {
    this.correspondenceFlag = false;
    this.rejectionFlag = false;
    this.scheduleFlag = false;
    this.getCandidateBasicDetails(selectedCandidate.applicationId, selectedCandidate.candidateId);
  }
  getCandidateBasicDetails(applicationId, candidateId) {
    this.associateService.getCandidateBasicDetails(applicationId, candidateId).subscribe((res) => {
      this.candidateBasicDetails = res;
    });
  }
  getActivitiesOnCandidate(candidate1) {
    this.groupedActivities = null;
    this.associateService
      .getActivitiesOnCandidate(candidate1.applicationId, candidate1.candidateId)
      .subscribe((result) => {
        this.activityModel = result.activityModel;
        const candidateActivities: any = [];
        console.log(this.processActivityList);

        if (this.activityModel) {
          this.activityModel.forEach((can) => {
            // this.processActivityList.forEach(process => {
            //   process.activityprocess.map(activityprocess => {
            // if (Number(ca.activityid) === Number(activityprocess.activityId)) {
            const returnobj: any = {
              editflag: this.getEditFlag(can),
              activityId: can.activityid,
              processId: can.processid,
              activityType: can.activityType,
              activityDescription: can.activityDescription,
              statusId: can.statusid,
              createdOn: can.createdOn,
              createdBy: can.createdBy,
              modifiedOn: can.modifiedOn,
              modifiedBy: can.modifiedBy,
            };
            // console.log('return object', returnobj);
            candidateActivities.push(returnobj);
            // }
            // });
            // })
          });
        }
        if (this.activityModel) {
          this.groupedActivities = candidateActivities.reduce((prev, activty1) => {
            prev[activty1.modifiedOn.substring(0, activty1.modifiedOn.indexOf('T'))] =
              prev[activty1.modifiedOn.substring(0, activty1.modifiedOn.indexOf('T'))] || [];
            prev[activty1.modifiedOn.substring(0, activty1.modifiedOn.indexOf('T'))].push(activty1);
            return prev;
          }, Object.create(null));

          console.log(this.groupedActivities);
        }
      });
  }

  // if(){

  // }
  getEditFlag(act) {
    const proces1 = this.processActivityList.filter((obj) => {
      return act.processid == obj.processId;
    })[0];

    let filterdObj1;
    if (proces1) {
      filterdObj1 = proces1.activityprocess.filter((item1) => {
        return act.activityid == item1.activityId;
      })[0];
    }
    if (filterdObj1) {
      return filterdObj1['edit'];
    } else {
      return false;
    }
  }
  filterChange(selectedActivity) {
    // telemtry interact call
    this.data.subtype = 'event click';
    this.data.pageid = '1';
    this.data.itype = 'particulat event click';
    this.data.stageto = 'changing the values according to the filter';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }

    console.log(selectedActivity);
    if (selectedActivity == 'All') {
      this.sourceFlag = true;
      this.technologyFlag = true;
    } else if (selectedActivity == 'Source') {
      this.sourceFlag = true;
      this.technologyFlag = false;
    } else if (selectedActivity == 'Technology') {
      this.technologyFlag = true;
      this.sourceFlag = false;
    }
  }

  displayService(item: activity) {
    this._telemetryServices.telemetryInteract(this.data);
    if (item.activityID === 5101) {
      this.rejectionFlag = false;
      this.correspondenceFlag = true;
      this.scheduleFlag = false;
      this.correspondenceObj = {
        candidateName: this.selectedCandidate[0].name,
        applicationId: this.selectedCandidate[0].applicationId,
        activityId: item.activityID,
      };
    } else if (item.activityID === 5103) {
      this.rejectionFlag = true;
      this.correspondenceFlag = false;
      this.scheduleFlag = false;
      this.rejectionObj = {
        candidateName: this.selectedCandidate[0].name,
        applicationId: this.selectedCandidate[0].applicationId,
        activityId: item.activityID,
      };
    }
  }
  receivedFile(event) {
    this.correspondenceAttachment = event;
    console.log(this.correspondenceAttachment);
    this.data.subtype = 'on event click';
    this.data.pageid = '1';
    this.data.itype = 'particular event click';
    this.data.stageto = 'received file page';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }
  }
  rejectFile(event) {
    this.rejectFile = event;
  }
  downloadTableData() {}
  cancelCorrespondenceTrigger() {
    // telemtry interact call

    this.data.subtype = 'on button click';
    this.data.pageid = '1';
    this.data.itype = 'cancel the correspondence trigger';
    this.data.stageto = 'cancelling the correspondence trigger';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }

    this.correspondenceFlag = false;
    this.getActivitiesOnCandidate(this.selectedCandidate);
  }
  cancelRejectionTrigger() {
    // telemtry interact call
    this.data.subtype = 'on button click';
    this.data.pageid = '1';
    this.data.itype = 'cancel the rejection trigger';
    this.data.stageto = 'cancelling the rejection trigger';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }

    this.rejectionFlag = false;
  }
  rejectTrigger(event) {
    // telemtry interact call

    this.data.subtype = 'on event click';
    this.data.pageid = '1';
    this.data.itype = 'particulat event click';
    this.data.stageto = 'reject component triggering';
    if (this.data) {
      this._telemetryServices.telemetryInteract(this.data);
    }

    console.log('in trigger');
    this.rejectionFlag = event;
    this.onCandidateReject.emit(true);
  }
  ngOnDestroy() {
    // telemtry end call
    this.data.subtype = 'Candidates Page stage/end of page';
    this.data.pageid = '1';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      this._telemetryServices.telemetryEnd(this.data);
    }
  }
}

// export class ApplicantDataSource extends DataSource<DashboardCandidate | undefined>{
//   private cachedCandidates = Array.from<DashboardCandidate>({ length: 0 });
//   private dataStream = new BehaviorSubject<(DashboardCandidate | undefined)[]>(this.cachedCandidates);
//   private subscription = new Subscription();

//   private pageSize = 10;
//   private lastPage = 0;
//   private dataIndex = 0;
//   constructor(private operationPersonaService: PersonaService) {
//     super();

//     // Start with some data.
//     this._fetchBatch(this.dataIndex);
//   }

//   connect(collectionViewer: CollectionViewer): Observable<(DashboardCandidate | undefined)[] | ReadonlyArray<DashboardCandidate | undefined>> {
//     this.subscription.add(collectionViewer.viewChange.subscribe(range => {
//       this._fetchBatch(this.dataIndex);
//     }));
//     return this.dataStream;
//   }

//   disconnect(collectionViewer: CollectionViewer): void {
//     this.subscription.unsubscribe();
//   }

//   private _fetchBatch(index: number): void {

//     this.operationPersonaService.getDashboardCandidateBatch(this.dataIndex).subscribe(response => {
//       this.cachedCandidates = this.cachedCandidates.concat(response);
//       this.dataStream.next(this.cachedCandidates);
//     });
//     this.dataIndex += 10;
//   }

// }

// export class ApplicantDataSource extends DataSource<Candidate | undefined>{
//   private cachedCandidates = Array.from<Candidate>({ length: 0 });
//   private dataStream = new BehaviorSubject<(Candidate | undefined)[]>(this.cachedCandidates);
//   private subscription = new Subscription();

//   private pageSize = 10;
//   private lastPage = 0;
//   private dataIndex = 0;
//   constructor(private operationPersonaService: PersonaService) {
//     super();

//     // Start with some data.
//     this._fetchBatch(this.dataIndex);
//   }

//   connect(collectionViewer: CollectionViewer): Observable<(Candidate | undefined)[] | ReadonlyArray<Candidate | undefined>> {
//     this.subscription.add(collectionViewer.viewChange.subscribe(range => {
//       this._fetchBatch(this.dataIndex);
//     }));
//     return this.dataStream;
//   }

//   disconnect(collectionViewer: CollectionViewer): void {
//     this.subscription.unsubscribe();
//   }

//   private _fetchBatch(index: number): void {

//     this.operationPersonaService.getCandidateBatch(this.dataIndex).subscribe(response => {
//       this.cachedCandidates = this.cachedCandidates.concat(response);
//       this.dataStream.next(this.cachedCandidates);
//     });
//     this.dataIndex += 10;
//     console.log(this.dataIndex);
//   }

// }
